const isStaticImageDef = (value: any): value is StaticImageDef =>
  value &&
  (value as StaticImageDef).src !== undefined &&
  (value as StaticImageDef).description !== undefined;

export default isStaticImageDef;
